var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex mt-3 mb-2", class: _vm.className }, [
    _vm.is3dRender
      ? _c(
          "div",
          { staticClass: "custom-pagination-3d ml-auto mr-auto" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  disabled: _vm.pagination.current_page < 2,
                  variant: "light",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.pagination.current_page - 1)
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-chevron-left" })]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "ml-1" }, [
              _vm._v(_vm._s(_vm.pagination.current_page)),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(" / ")]),
            _vm._v(" "),
            _c("span", { staticClass: "mr-1" }, [
              _vm._v(_vm._s(_vm.pagination.last_page)),
            ]),
            _vm._v(" "),
            _c(
              "b-button",
              {
                attrs: {
                  disabled:
                    _vm.pagination.current_page >= _vm.pagination.last_page,
                  variant: "light",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.changePage(Number(_vm.pagination.current_page) + 1)
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-chevron-right" })]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.is3dRender
      ? _c(
          "ul",
          { staticClass: "pagination ml-auto mr-auto" },
          [
            _vm.pagination.current_page > 1
              ? _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "javascript:void(0)",
                        "aria-label": "First",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changePage(1)
                        },
                      },
                    },
                    [_vm._v("\n        «\n      ")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pagination.current_page > 1
              ? _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "javascript:void(0)",
                        "aria-label": "Previous",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changePage(_vm.pagination.current_page - 1)
                        },
                      },
                    },
                    [_vm._v("\n        <\n      ")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pagesNumber.length > 1
              ? _vm._l(_vm.pagesNumber, function (page) {
                  return _c(
                    "li",
                    {
                      key: page,
                      class: { active: page == _vm.pagination.current_page },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.changePage(page)
                            },
                          },
                        },
                        [_vm._v(_vm._s(page))]
                      ),
                    ]
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.pagination.current_page < _vm.pagination.last_page
              ? _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "javascript:void(0)",
                        "aria-label": "Next",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.changePage(
                            Number(_vm.pagination.current_page) + 1
                          )
                        },
                      },
                    },
                    [_vm._v("\n        >\n      ")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pagination.current_page < _vm.pagination.last_page
              ? _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "javascript:void(0)",
                        "aria-label": "Last",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changePage(_vm.pagination.last_page)
                        },
                      },
                    },
                    [_vm._v("\n        »\n      ")]
                  ),
                ])
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }